module.exports = __webpack_public_path__ + "/images/cover-hucha-inicio.fr-FR.8039d06.png";